
import styles from './style.module.css';
import React, { useEffect, useState } from "react";
import { getMainInfo } from "store/HomeSlice";
import { useDispatch, useSelector } from "react-redux";
import { getAbouUsPageData } from "store/MainSlice";
import { getBrand } from "../../store/MainSlice";
import MainBanner from "./components/MainBanner";
import VideoSection from "./components/VideoSection";
import BrandCarousel from "./components/BrandCarusel";
import Advantages from "./components/Advantages";
import Members from "./components/Members";
import News from "./components/News";
import Branches from "./components/Branches";
import BankSection from "./components/BankSection";
import Brand from 'components/Brand';
import langData from "../../lang/data";
import {Link} from "react-router-dom";
import ArrowSvg from "../../assets/SVG/ArrowSvg";

function NewAboutUs() {

    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState(false);
    const { currentLanguage, aboutUsPageData, brands } = useSelector(({ main }) => main);

    useEffect(() => {
        dispatch(getMainInfo());
        dispatch(getAbouUsPageData());
        dispatch(getBrand());
    }, [dispatch]);

    return (
        <div className={styles.container}>
            <MainBanner banner = { aboutUsPageData?.baner }/>
            <VideoSection data = {aboutUsPageData?.about_us["block_1_" + currentLanguage]}/>
            <BrandCarousel
                brands={brands?.slice(0, Math.ceil((brands?.length || 0) / 2)) || []}
                top={50}
            />
            <BrandCarousel
                brands={brands?.slice(Math.ceil((brands?.length || 0) / 2)) || []}
                top={16}
                left={80}
                reverse
            />
            <div className={styles.brandButtonBox}>
                <Link
                    to = {`${currentLanguage !== "hy" ? "/" + currentLanguage : ""}/brandSeeAll`}
                    style = {{
                        color: 'var(--red)'
                    }}
                >
                    { langData.buttons.view_all[currentLanguage] }
                </Link>
                <ArrowSvg
                    width = {15}
                    height = {9}
                    rotate = {90}
                    color = {'red'}
                />
            </div>
            <div
                className = {`${styles.description_box} ${expanded ? styles.expanded : styles.collapsed}`}
                dangerouslySetInnerHTML = {{__html: aboutUsPageData?.about_us[`block_4_${currentLanguage}`]}}
            />
            <div
                style = {{
                    width: '100%',
                    maxWidth: '1440px',
                    margin: '0 auto 30px auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    paddingRight: '20px',
                }}
            >
                <button
                    onClick = {() => setExpanded(prev => !prev)}
                    className = {styles.moreLessBtn}
                >
                    {expanded ? langData.buttons.see_less[currentLanguage] : langData.buttons.see_more[currentLanguage]}
                    <ArrowSvg
                        width = {15}
                        height = {9}
                        rotate = {expanded ? 0 : 180}
                        color = {'red'}
                    />
                </button>
            </div>
            <Advantages/>
            <Members
                image={process.env.REACT_APP_STORAGE_URL + aboutUsPageData?.about_us["block_6_image_" + currentLanguage]}
                title={aboutUsPageData?.about_us["block_6_title_" + currentLanguage]}
                text={aboutUsPageData?.about_us["block_6_text_" + currentLanguage]}
                link={aboutUsPageData?.about_us["block_6_link_" + currentLanguage]}
                linkText={aboutUsPageData?.about_us["block_6_link_text_" + currentLanguage]}
            />
            <News news = { aboutUsPageData?.news || [] }/>
            <Branches/>
            <BankSection/>
            {/*<button className={styles.view_all_button}>*/}
            {/*    { langData.buttons.view_all[currentLanguage] }*/}
            {/*</button>*/}
        </div>
    )
}

export default NewAboutUs